module.exports = __webpack_public_path__ + "static/brush-344c38e3c8a24272efda53e06e72e9cd.svg";